import { motion } from 'framer-motion';
import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import Footer from './Footer';

const Nav = () => {
	return (
		<>
			<motion.div
				initial={{ x: -500 }}
				animate={{ x: 0 }}
				transition={{ duration: 1 }}
				className="navigation-bar"
			>
				<Link className="links" smooth to="#home">
					<p>Home</p>
				</Link>
				<Link className="links" smooth to="#about">
					<p>About</p>
				</Link>
				<Link className="links" smooth to="#experience">
					<p>Experience</p>
				</Link>
				<Link className="links" smooth to="#works">
					<p>Works</p>
				</Link>
				<Footer className="footer" />
			</motion.div>
		</>
	);
};

export default Nav;
